export enum AuditlogId {
  HOME = 'hsformHome',
  MANAGE_FORM="hsformManageForm",
  MANAGE_QUESTION="hsformManageQuestion",
  MANAGE_SYSTEM="hsformManageSystem",
  MANAGE_WORDMARKS="hsformManageWordMarks",
  MANAGE_SUBMISSIONS="hsformManageSubmissions",
  VIEW_FORM="hsformViewForm",
  VIEW_FORM_SAVE_FOR_LATER="hsformManageFormSaveForLater",
  MANAGE_FORM_EDIT="hsformManageFormEdit" ,
  MANAGE_FORM_COPY="hsformManageFormCopy"
}

export enum AuditlogEventType {
  VIEW = 'VIEW',
  ADD = 'ADD',
  MODIFY = 'MODIFY',
  EXECUTE = 'EXECUTE',
  DELETE = 'DELETE',
  ACTIVATE = 'ACTIVATE',
  INACTIVATE = 'INACTIVATE',
  REPLACE = 'REPLACE',
  RESET = 'RESET',
	CLEAR = 'CLEAR',
	PREVIEW = 'PREVIEW',
	CHANGE_QUESTION_ORDER = 'CHANGE_QUESTION_ORDER',
	CHANGE_SECTION_ORDER = 'CHANGE_SECTION_ORDER',
  EXPORT_DATA = 'EXPORT_DATA',
  SAVE_FOR_LATER = 'SAVE_FOR_LATER',
  COPY = 'COPY'
}

export enum AuditLogInterfaceName {
  HOME = 'Home',
  MANAGE_FORMS = 'Manage Forms',
  MANAGE_QUESTIONS = 'Manage Questions',
  MANAGE_SYSTEM = 'Manage System',
  MANAGE_SUBMISSIONS = 'Manage Forms / Manage Submissions',
  VIEW_FORM = 'Manage Forms / View Form',
  MANAGE_SUBMISSIONS_RESET_TAB = 'Reset/Clear Submissions',
  MANAGE_SUBMISSIONS_VIEW_TAB = 'View/Export Submissions',
  MANAGE_FORM_EDIT = 'Manage Forms/Edit'
}
